"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
const useStyles = (data, getValueText) => {
  const {
    fontFamily,
    basicFontSize,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const totalSum = data ? data.reduce((sum, item) => sum + item.value, 0) : 0;
  const maxValueWidth = data && getValueText ? Math.max(...data.map(i => getValueText(i.value, i.legendText).length * 8)) : 0;
  const maxLegendWidth = data ? Math.max(...data.map(i => i.legendText.length * 8)) : 0;
  const ccColorScaleStyle = (0, _react.useMemo)(() => {
    const ccColorScale = (0, _css.css)({
      fontSize: basicFontSize,
      fontFamily: fontFamily
    });

    /* Line view mode */

    const ccLine = (0, _css.css)({
      height: pxToRem(8),
      width: '100%',
      borderRadius: pxToRem(6),
      background: themeColors?.basic.main,
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch'
    });
    const ccLinePart = (value, color) => (0, _css.css)({
      position: 'relative',
      flex: 'none',
      width: value > 0 && totalSum > 0 ? value * 100 / totalSum + '%' : '0%',
      transition: 'width 0.5s linear',
      background: color
    });
    const ccLineTooltipItem = (0, _css.css)({
      display: 'grid',
      alignItems: 'center',
      justifyItems: 'start',
      alignContent: 'stretch',
      justifyContent: 'start',
      gridTemplateColumns: 'auto auto',
      columnGap: pxToRem(10),
      '&:not(:last-child)': {
        marginBottom: pxToRem(10)
      }
    });
    const ccLineTooltipItemScale = (0, _css.css)({
      width: pxToRem(16),
      height: pxToRem(5),
      borderRadius: pxToRem(6)
    });
    const ccLineTooltipItemValue = (0, _css.css)({
      color: '#575962'
    });

    /* Table view mode */

    const ccTableItem = (0, _css.css)({
      display: 'grid',
      alignItems: 'center',
      justifyItems: 'start',
      alignContent: 'stretch',
      justifyContent: 'space-between',
      gridTemplateColumns: `${pxToRem(maxValueWidth)} 1fr ${pxToRem(maxLegendWidth)}`,
      columnGap: pxToRem(10),
      '&:not(:last-child)': {
        marginBottom: pxToRem(10)
      }
    });
    const ccTableItemValue = (0, _css.css)({
      width: '100%',
      textAlign: 'center'
    });
    const ccTableItemScale = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      alignItems: 'stretch',
      width: '100%',
      justifyContent: 'center'
    });
    const ccTableItemLegend = (0, _css.css)({});

    /* Legend view mode */

    const ccLegend = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      columnGap: pxToRem(16)
    });
    const ccLegendItem = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      columnGap: pxToRem(6),
      fontSize: pxToRem(14),
      div: {
        width: pxToRem(36),
        height: pxToRem(8),
        borderRadius: pxToRem(6)
      }
    });
    const ccLegendItemText = (0, _css.css)({
      color: themeColors?.basic.dark
    });
    return {
      ccColorScale,
      ccLine,
      ccLinePart,
      ccLineTooltipItem,
      ccLineTooltipItemScale,
      ccLineTooltipItemValue,
      ccTableItem,
      ccTableItemValue,
      ccTableItemScale,
      ccTableItemLegend,
      ccLegend,
      ccLegendItem,
      ccLegendItemText
    };
  }, [totalSum, maxValueWidth, maxLegendWidth, fontFamily, basicFontSize, themeColors?.basic, pxToRem]);
  return {
    'cc-ColorScale': ccColorScaleStyle.ccColorScale,
    'cc-ColorScale__line': ccColorScaleStyle.ccLine,
    'cc-ColorScale__line__part': ccColorScaleStyle.ccLinePart,
    'cc-ColorScale__line-tooltip-item': ccColorScaleStyle.ccLineTooltipItem,
    'cc-ColorScale__line-tooltip-item__scale': ccColorScaleStyle.ccLineTooltipItemScale,
    'cc-ColorScale__line-tooltip-item__value': ccColorScaleStyle.ccLineTooltipItemValue,
    'cc-ColorScale__table-item': ccColorScaleStyle.ccTableItem,
    'cc-ColorScale__table-item__value': ccColorScaleStyle.ccTableItemValue,
    'cc-ColorScale__table-item__scale': ccColorScaleStyle.ccTableItemScale,
    'cc-ColorScale__table-item__legend': ccColorScaleStyle.ccTableItemLegend,
    'cc-ColorScale__legend': ccColorScaleStyle.ccLegend,
    'cc-ColorScale__legend-item': ccColorScaleStyle.ccLegendItem,
    'cc-ColorScale__legend-item-text': ccColorScaleStyle.ccLegendItemText
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;